// Engineering Images
export const engineeringImages = {
  newProductDev: 'https://customer-assets.emergentagent.com/job_cad-solutions/artifacts/ilm66s3n_New%20Product%20Dev%203.png',
  cadDesign: 'https://customer-assets.emergentagent.com/job_cad-solutions/artifacts/21no8xgw_CAD%202.png',
  procurement: 'https://customer-assets.emergentagent.com/job_cad-solutions/artifacts/ls97cu06_Procurement%20and%20Source.png',
  sustenance: 'https://customer-assets.emergentagent.com/job_cad-solutions/artifacts/gsqqi4eg_Sustanance%20engineering%201.png',
  fea: 'https://customer-assets.emergentagent.com/job_cad-solutions/artifacts/dl6exoxf_Analysis%20FEA.png'
};

// Service specific images
export const serviceImages = [
  engineeringImages.newProductDev,  // Concept Design
  engineeringImages.cadDesign,      // 3D Modeling
  engineeringImages.procurement,    // Design for Manufacture
  engineeringImages.sustenance,     // Reverse Engineering
  engineeringImages.fea,            // Detailed Engineering
  engineeringImages.cadDesign       // Sustenance Engineering
];

// Industry images mapping
export const industryImages = [
  'https://images.unsplash.com/photo-1567789884554-0b844b597180', // Heavy Equipment
  'https://images.unsplash.com/photo-1455165814004-1126a7199f9b', // Industrial Machinery
  'https://images.unsplash.com/photo-1567093322102-6bdd32fba67d', // Automotive
  'https://images.unsplash.com/photo-1717386255773-1e3037c81788', // Consumer Products
  'https://images.pexels.com/photos/31336881/pexels-photo-31336881.jpeg' // Process Equipment
];

// Project images
export const projectImages = [
  engineeringImages.fea,
  engineeringImages.cadDesign,
  engineeringImages.sustenance
];

// About/Team images
export const aboutImages = {
  engineering: engineeringImages.fea,
  workshop: engineeringImages.newProductDev,
  quality: engineeringImages.sustenance
};